import { brandLabelFromHost, isApplyHost } from '@zealot/shared/brands/brandLabelFromHost';

export type BrandHintSource = {
  url: URL;
  hostname: string;
};

// gloss
const RESERVED_PARAM_KEYS = new Set([
  'brand',
  'brandname',
  'embed',
  'token',
  'code',
  'email',
  'invitetag',
  'clearcache',
  'actor',
  'slot',
]);

// gloss
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);

// gloss
export const applyLinkBrandParam = ({ url, hostname }: BrandHintSource): string | null => {
  if (!isApplyHost(hostname) && !LOCAL_HOSTS.has(hostname.toLowerCase())) return null;
  const [first] = url.searchParams.entries();
  if (!first) return null;
  const [key, value] = first;
  const name = key.trim();
  if (value !== '' || !name) return null;
  const lower = name.toLowerCase();
  if (RESERVED_PARAM_KEYS.has(lower) || lower.startsWith('utm_')) return null;
  return name;
};

// gloss
export const brandHintFromUrl = ({ url, hostname }: BrandHintSource): string | null => {
  const fromQuery = url.searchParams.get('brand');
  if (fromQuery) return fromQuery.toLowerCase();
  const fromApplyLink = applyLinkBrandParam({ url, hostname });
  if (fromApplyLink) return fromApplyLink.toLowerCase();

  return brandLabelFromHost(hostname) ?? null;
};
